import { AbstractHttpClient, CrudApi } from "@clairejs/client";
import { Register } from "@clairejs/core";

import { SystemAnnounce } from "../../dto/models/system-announce";

import { SystemSettingTemplate } from "../../dto/http/system";

interface UploadUrlResponse {
    objectKey: string;
    putPresignedUrl: string;
    deletePresignedUrl: string;
}

export type UploadHandlerFn = (ext?: string) => Promise<UploadUrlResponse>;

export interface GetUploadUrlResponseBody {
    files: {
        objectKey: string;
        putPresignedUrl: string;
        deletePresignedUrl: string;
    }[];
}

@Register()
export class SystemApi {
    constructor(protected readonly http: AbstractHttpClient) {}

    async getSystemSettings() {
        return await this.http.get<SystemSettingTemplate>("/systemsetting");
    }

    async updateSystemSettings(settings: SystemSettingTemplate) {
        await this.http.put("/systemsetting", settings);
    }

    async getUploadUrl(ext: string[]) {
        const result = await this.http.get<GetUploadUrlResponseBody>(
            `/upload/presigned?extensions=${JSON.stringify(ext)}`,
            {},
            { noCache: true },
        );
        return result;
    }
}

@Register()
export class SystemAnnounceApi extends CrudApi<SystemAnnounce> {
    constructor(protected readonly http: AbstractHttpClient) {
        super(SystemAnnounce, http);
    }
}
